<div class="modal-header bg-success d-flex align-items-center">
<!--  <h4 class="modal-title text-muted">{{page}}</h4>-->
  <div></div>
  <button type="button" class="close pull-right btn" aria-label="Close" (click)="closeModal()">
    <i class="fa fa-times" aria-hidden="true"></i>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12 m-3">
      <baxter-auth (successLogin)="successLogin()" [toastrService]="toastr" [application]="'REPO_LEND'"></baxter-auth>
    </div>
  </div>

<!--  <div *ngIf="page === 'Login'">-->
<!--    <baxter-auth (successLogin)="successLogin()" [toastrService]="toastr" [application]="'REPO_LEND'"></baxter-auth>-->
<!--    <div *ngIf="isRegisterEnabled">-->
<!--      Haven't got account? click <span class="authentication-link" (click)="goToRegister()">here</span> to register-->
<!--    </div>-->
<!--  </div>-->
<!--  <div *ngIf="page === 'Register to demo'">-->
<!--    <app-register></app-register>-->
<!--    <div>-->
<!--      You already have an account? Click <span class="authentication-link" (click)="goToLogin()">here</span> to log in-->
<!--    </div>-->
<!--  </div>-->
</div>

